module.exports = __webpack_public_path__ + "static/media/trophy.028d6dc8.png";